import { useState, useEffect } from 'react'

import ModalDisableUser from '../Modals/ConfirmDisableUserSuscriber'
// import { SearchBarAndFiltersUserOfSuscriber } from '../SearchAndFIlter/SearchBarAndFiltersUserOfSuscriber'
import TableHeader from './TableHeader/TableHeader'
import TableItem from './TableItem/TableItem'

import useStyles from './useStyles'
import { useDispatch } from 'react-redux'
import {
  getOrganizationCommercialUserType,
  getTypesUser
} from '../../../../redux/actions/Organizations'
import {
  getSubscriberStatus,
  getUserOfSuscribersWithID
} from '../../../../redux/actions/Suscriber'
import { getUserStatusCorpEntities } from '../../../../app/services/Organization/getUserStatusCorpEntities'

function UsersTable({ id, rows, setRows, setLoading }) {
  const classes = useStyles()
  // // hook open modal for deleted user
  const [openModalDisableUser, setOpenModalDisableUser] = useState(false)
  const [types, setTypes] = useState([])
  const [typesComercial, setTypesComercial] = useState([])
  const [typesStatus, setTypesStatus] = useState([])
  const [userTypes, setUserTypes] = useState([])

  const dispatch = useDispatch()

  const getUserOrgStatus = async () => {
    try {
      const status = await getUserStatusCorpEntities()
      setUserTypes(status.data?.data)
    } catch (error) {
      console.log(error)
      setUserTypes([])
    }
  }

  // get types user request
  const setTypesUser = async () => {
    const response = await dispatch(getTypesUser())
    setTypes(response)
  }

  // get types comercial request
  const getTypesComercialUser = async () => {
    const response = await dispatch(getOrganizationCommercialUserType())
    setTypesComercial(response.data)
  }
  // get user request
  const getUsersOfSuscriber = async () => {
    setRows(await dispatch(getUserOfSuscribersWithID(id)))
  }

  const getStatus = async () => {
    const response = await dispatch(getSubscriberStatus())
    setTypesStatus(response)
  }
  // get users of Suscriber of Organization
  useEffect(async () => {
    setLoading(true)
    await setTypesUser()
    await getTypesComercialUser()
    await getStatus()
    await getUsersOfSuscriber()
    await getUserOrgStatus()
    setLoading(false)
  }, [id])

  return (
    <>
      <div className={classes.root}>
        <ModalDisableUser
          setLoading={setLoading}
          setRows={setRows}
          openModalDisableUser={openModalDisableUser}
          setOpenModalDisableUser={setOpenModalDisableUser}
        />
        <div className={classes.tableWrap}>
          <table className={classes.table}>
            <TableHeader />
            <tbody className={classes.tableBody}>
              {rows &&
                rows.map((item, index) => (
                  <TableItem
                    listIndex={index}
                    key={item.user_id}
                    item={item}
                    setLoading={setLoading}
                    setRows={setRows}
                    setOpenModalDisableUser={setOpenModalDisableUser}
                    types={types}
                    typesComercial={typesComercial}
                    typesStatus={typesStatus}
                    userTypes={userTypes}
                  />
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}
export default UsersTable
